import Code from 'eflex/models/code';

export default class ScrapCode extends Code {}
